import {
	message,
	Typography,
} from 'antd';
import {
	Button, Card, Form, Input,
	Space,
} from 'antd-mobile';
import React, { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from '@hcaptcha/react-hcaptcha';

import { APP_CONFIG } from '../../config';
import cqHeaderImag from '../../assets/icons/cq_logo_primary.png';
import chitkaraHeaderImage from '../../assets/icons/chitkara-university-logo.png';
// import './forgot-password-form.scoped.css';

const headerImag = (APP_CONFIG.isChitkara) ? chitkaraHeaderImage : cqHeaderImag;

interface ForgetPasswordFormProps {
	onForgot: (data: forgotPasswordPayload) => Promise<void>
	goBack: () => void,
}

export const ForgotPasswordForm = (props: ForgetPasswordFormProps) => {
	const { onForgot, goBack } = props;
	const [sendingRequest, setSendingRequest] = useState<boolean>(false);
	const [captia, setCaptia] = useState<string | null>(null);
	const inputStyle = {
		border: 'none',
		borderBottom: '1px solid #d9d9d9',
		borderRadius: 0,
	};

	const recaptchaRef = useRef<any>();

	const sendForgotPasswordRequest = useCallback(async (data) => {
		try {
			const { email } = data;
			if (!captia) throw new Error('Please validate reCAPTCHA first.');
			setSendingRequest(true);
			await onForgot({ email, captia });
			message.success('Please check your email.');
			goBack();
		} catch (error: any) {
			console.log(error);
			message.error(error?.message ?? error);
		} finally {
			if (recaptchaRef.current) {
				recaptchaRef.current.resetCaptcha();
			}
			setSendingRequest(false);
		}
	}, [captia, goBack, onForgot]);

	return (
		<Card>
			<Form
				layout="vertical"
				onFinish={sendForgotPasswordRequest}
				style={{
					'--border-top': 'none',
					'--border-inner': 'none',
					'--border-bottom': 'none',
				}}
			>
				<div id="banner-holder">
					<Typography.Title level={2}>forgot password</Typography.Title>
				</div>
				<Form.Item
					label="enter your registered email address"
					name="email"
					rules={[
						{ required: true, whitespace: true, message: 'Please enter email!' },
						{ type: 'email', message: 'Please enter valid email' },
					]}
					normalize={(value, prevVal, prevVals) => value.trim()}
				>
					<Input id="formgotEmailInput" placeholder="email" style={inputStyle} />
				</Form.Item>
				<Form.Item
					name="captia"
				>
					<div style={{ marginTop: '1rem' }}>
						<ReCAPTCHA
							ref={recaptchaRef}
							sitekey={APP_CONFIG.CaptiaKey}
							onVerify={setCaptia}
						/>
					</div>
				</Form.Item>
				<Form.Item>
					<Space direction="vertical" style={{ width: '100%' }}>
						<Button
							type="submit"
							size="large"
							color="primary"
							loading={sendingRequest}
							style={{ width: '100%' }}
						>
							confirm
						</Button>
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<Button onClick={goBack} fill="none">Go Back</Button>
						</div>
					</Space>
				</Form.Item>
			</Form>
		</Card>
	);
};
